
import { useContext, useEffect, useState } from 'react'

import { ContextApi } from '../../context/contextApi';
import { SwitchMui } from '../../libs/inputs/switchMui'
import { Upload } from '../../libs/inputs/uploadImage';
import { hydrateSpotInfo, serializeSpotInfo } from '../../libs/spot/spotData';

import styles from './style.module.scss'

export function EditDadosAvancados({ 
    idCam,
    setInfoPrincipais,
    setInfoAvancadas
}) {
    const {
        getCameraForId,
        cameraId,
        updateCamera,
    } = useContext(ContextApi);
    const [switchVisibilit, setSwitchVisibilit] = useState(true);
    const [switchAdAnuncio, setSwitchAdAnuncio] = useState(false);
    const [switchShowAnuncioUmaVez, setSwitchShowAnuncioUmaVez] = useState(false);
    const [imageLogoDireitaB64, setImageLogoDireitaB64] = useState('');
    const [imageLogoEsquerdaB64, setImageLogoEsquerdaB64] = useState('');
    const [imagePosterB64, setImagePosterB64] = useState('');
    const [imagePlanoFundoB64, setImagePlanoFundoB64] = useState('');

    useEffect(() => {
        getCameraForId(idCam)
    }, [])

    useEffect(() => {
        setSwitchVisibilit(cameraId?.visibilidade);
        setSwitchAdAnuncio(cameraId?.ad_anuncio);
        setSwitchShowAnuncioUmaVez(cameraId?.ad_anuncio_single);
    }, [cameraId])

    async function handlerSubmitUpdateCam() {
        try {
          await updateCamera(
            idCam,
            {           
                stream_id: cameraId?.stream_id,
                estado_sigla: cameraId?.estado_sigla,
                estado_imagem: "",
                estado: cameraId?.estado,
                area_regiao_id: cameraId?.area_regiao_id || cameraId?.area_regiao?.id,
                cidade: cameraId?.cidade,
                nome_camera: cameraId?.nome_camera,
                parceiro: cameraId?.parceiro,
                parceiro_link: cameraId?.parceiro_link,
                stream_hls: "",
                referencia: cameraId?.referencia,
                status: true,
                visibilidade: switchVisibilit,
                digest: "",
                marca_dagua_superior_direito: imageLogoDireitaB64 || cameraId?.marca_dagua_superior_direito || null,
                marca_dagua_superior_esquerdo: imageLogoEsquerdaB64 || cameraId?.marca_dagua_superior_esquerdo || null,
                poster: imagePosterB64 || cameraId?.poster || null,
                previsao_metereologica: cameraId?.previsao_metereologica,
                descricao: cameraId?.descricao,
                ad_anuncio: switchAdAnuncio,
                ad_anuncio_single: switchShowAnuncioUmaVez,
                disponibilidade: cameraId?.disponibilidade,
                embeded_monuv: cameraId?.embeded_monuv,
                logo: imagePlanoFundoB64 || cameraId?.logo || null,
                ...serializeSpotInfo(hydrateSpotInfo(cameraId))
            },
          )
          getCameraForId(idCam);
        } catch {
          // O ContextApi informa a falha; não descartar as alterações locais.
        }
    }

    return (
        <div className={styles.containerDadosPrincipais}>
            <div className={styles.boxSwitch}>
                <SwitchMui 
                optionSwitchCheck='OnLine' 
                optionSwitchUncheck='OffLine'
                label='Visibilidade'
                switchResult={switchVisibilit}
                setSwitchResult={setSwitchVisibilit}
                />
                <SwitchMui 
                optionSwitchCheck='Sim' 
                optionSwitchUncheck='Não'
                label='Add anuncio'
                switchResult={switchAdAnuncio}
                setSwitchResult={setSwitchAdAnuncio}
                />
            </div>
            <div className={styles.boxSwitch}>
                <SwitchMui 
                optionSwitchCheck='Sim' 
                optionSwitchUncheck='Não'
                label='Mostrar anúncio apenas uma vez?'
                switchResult={switchShowAnuncioUmaVez}
                setSwitchResult={setSwitchShowAnuncioUmaVez}
                />
            </div>
            <Upload 
            labelUploadImage='Logo Esquerda'
            imageB64={imageLogoEsquerdaB64}
            setImageB64={setImageLogoEsquerdaB64}
            allTypesImage={false}
            imgDefault={cameraId?.marca_dagua_superior_esquerdo}
            idCamDefault={{
                id: cameraId?.id,
                tagName: 'marca_dagua_superior_esquerdo'
            }}
            setInfoPrincipais={setInfoPrincipais}
            setInfoAvancadas={setInfoAvancadas}
            />
            <Upload 
            labelUploadImage='Logo direita'
            imageB64={imageLogoDireitaB64}
            setImageB64={setImageLogoDireitaB64}
            allTypesImage={false}
            imgDefault={cameraId?.marca_dagua_superior_direito}
            idCamDefault={{
                id: cameraId?.id,
                tagName: 'marca_dagua_superior_direito'
            }}
            setInfoPrincipais={setInfoPrincipais}
            setInfoAvancadas={setInfoAvancadas}
            />
            <Upload 
            labelUploadImage='Poster'
            imageB64={imagePosterB64}
            setImageB64={setImagePosterB64}
            allTypesImage={true}
            imgDefault={cameraId?.poster}
            idCamDefault={{
                id: cameraId?.id,
                tagName: 'poster'
            }}
            setInfoPrincipais={setInfoPrincipais}
            setInfoAvancadas={setInfoAvancadas}
            />
            <Upload 
            labelUploadImage='Plano de fundo'
            imageB64={imagePlanoFundoB64}
            setImageB64={setImagePlanoFundoB64}
            allTypesImage={true}
            imgDefault={cameraId?.logo}
            idCamDefault={{
                id: cameraId?.id,
                tagName: 'logo'
            }}
            setInfoPrincipais={setInfoPrincipais}
            setInfoAvancadas={setInfoAvancadas}
            />
            <div className={styles.boxBTNSubmit}>
                <span
                onClick={() => handlerSubmitUpdateCam()}
                >Salvar</span>
            </div>
        </div>
    )
}
